import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Animation immédiate au chargement pour les éléments "load-*"
    this.animateOnLoad()

    // Observer pour animations au scroll
    this.observeScrollElements()
  }

  animateOnLoad() {
    const loadElements = this.element.querySelectorAll('[data-animation^="load-"]')

    loadElements.forEach((element, index) => {
      const animationType = element.dataset.animation
      const delay = element.dataset.animationDelay ? parseInt(element.dataset.animationDelay) : 0

      setTimeout(() => {
        this.triggerAnimation(element, animationType, delay)
      }, delay)
    })
  }

  observeScrollElements() {
    const scrollElements = this.element.querySelectorAll('[data-animation^="scroll-"]')

    if (scrollElements.length === 0) return

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !entry.target.dataset.animated) {
          const animationType = entry.target.dataset.animation
          this.triggerAnimation(entry.target, animationType)
          entry.target.dataset.animated = 'true'
        }
      })
    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -10% 0px'
    })

    scrollElements.forEach(element => observer.observe(element))
  }

  triggerAnimation(element, animationType, baseDelay = 0) {
    const children = Array.from(element.children)

    switch(animationType) {
      case 'load-cascade':
        this.cascadeAnimation(children, { delay: baseDelay, increment: 150, translateY: 20 })
        break
      case 'load-fade-up':
        this.fadeUpAnimation(children, { delay: baseDelay, translateY: 30 })
        break
      case 'scroll-fade-up':
        this.fadeUpAnimation(children, { delay: 0, translateY: 30 })
        break
      case 'scroll-stagger':
        this.staggerAnimation(children, { delay: 0, increment: 100, scale: 0.95 })
        break
      case 'scroll-fade-rotate':
        this.fadeRotateAnimation(element, { delay: 0 })
        break
      default:
        this.fadeUpAnimation(children, { delay: 0, translateY: 30 })
    }
  }

  cascadeAnimation(children, options = {}) {
    const { delay = 0, increment = 150, translateY = 20 } = options

    children.forEach((child, index) => {
      child.style.opacity = '0'
      child.style.transform = `translateY(${translateY}px)`

      setTimeout(() => {
        child.style.transition = 'opacity 800ms ease-out, transform 800ms ease-out'
        child.style.opacity = '1'
        child.style.transform = 'translateY(0)'
      }, delay + (index * increment))
    })
  }

  fadeUpAnimation(children, options = {}) {
    const { delay = 0, translateY = 30 } = options

    children.forEach(child => {
      child.style.opacity = '0'
      child.style.transform = `translateY(${translateY}px)`

      setTimeout(() => {
        child.style.transition = 'opacity 600ms ease-out, transform 600ms ease-out'
        child.style.opacity = '1'
        child.style.transform = 'translateY(0)'
      }, delay)
    })
  }

  staggerAnimation(children, options = {}) {
    const { delay = 0, increment = 100, scale = 0.95 } = options

    children.forEach((child, index) => {
      child.style.opacity = '0'
      child.style.transform = `scale(${scale})`

      setTimeout(() => {
        child.style.transition = 'opacity 500ms ease-out, transform 500ms ease-out'
        child.style.opacity = '1'
        child.style.transform = 'scale(1)'
      }, delay + (index * increment))
    })
  }

  fadeRotateAnimation(element, options = {}) {
    const { delay = 0 } = options
    const child = element.firstElementChild

    if (!child) return

    child.style.opacity = '0'
    child.style.transform = 'translateY(20px) rotate(-1deg)'

    setTimeout(() => {
      child.style.transition = 'opacity 800ms ease-out, transform 800ms ease-out'
      child.style.opacity = '1'
      child.style.transform = 'translateY(0) rotate(0deg)'
    }, delay)
  }
}